import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Clock, Mail, ArrowLeft } from 'lucide-react';

export default function TrialPending() {
  const location = useLocation();
  const email = location.state?.email;
  const organisationName = location.state?.organisationName;

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center p-4" data-testid="trial-pending-page">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#1ABC9C]">Elara</h1>
          <p className="text-[#C7C7C7] mt-2">Workforce Management System</p>
        </div>

        <Card className="bg-[#2B2B2B] border-white/5">
          <CardHeader className="text-center">
            <div className="mx-auto w-14 h-14 rounded-full bg-[#1ABC9C]/10 border border-[#1ABC9C]/30 flex items-center justify-center mb-4">
              <Clock className="w-7 h-7 text-[#1ABC9C]" />
            </div>
            <CardTitle className="text-[#F2F2F2] text-2xl">Your trial request is in</CardTitle>
            <CardDescription className="text-[#C7C7C7] mt-2">
              Thanks{organisationName ? `, ${organisationName}` : ''} — your request has been received.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-5">
            <div className="rounded-md border border-white/5 bg-[#1A1A1A]/60 px-4 py-3 text-sm text-[#C7C7C7]">
              <p className="font-medium text-[#F2F2F2] mb-1">What happens next</p>
              <p>
                Elara is finalising its self-service onboarding. As soon as your private workspace is provisioned, we'll email
                {email ? ' ' : ' you'}<span className="text-[#1ABC9C]">{email}</span> with the activation link and your 7-day trial will start automatically.
              </p>
            </div>

            <div className="rounded-md border border-[#1ABC9C]/20 bg-[#1ABC9C]/5 px-4 py-3 text-sm text-[#C7C7C7] flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-[#1ABC9C] shrink-0" />
              <div>
                <p className="font-medium text-[#F2F2F2]">Need to speak to someone sooner?</p>
                <p className="mt-1">
                  Email{' '}
                  <a
                    href="mailto:hello@elarasystems.co.uk"
                    className="text-[#1ABC9C] hover:underline"
                    data-testid="trial-pending-contact-link"
                  >
                    hello@elarasystems.co.uk
                  </a>{' '}
                  and we'll walk you through the platform in a live call.
                </p>
              </div>
            </div>

            <Button
              asChild
              variant="outline"
              className="w-full border-white/10 text-[#F2F2F2] hover:bg-white/5"
              data-testid="trial-pending-back-link"
            >
              <Link to="/">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to homepage
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
